import React from "react";
import { connect } from "react-redux";

import { withRouter, Link } from "react-router-dom";

import CheckboxTableManual from "components/Common/CheckboxTableManual/CheckboxTableManual";

import { Button, ButtonToolbar, DropdownButton, Dropdown } from "react-bootstrap";

// import countryList from "react-select-country-list";

import { Tooltip } from "components/Common/Tooltip/";

import {
  loadCompanyStart,
} from "services/redux/actions/company";

import { loadCompanyCreateEnterpriseReset, loadSiteAssetsReset } from "services/redux/actions/serviceDesk.js";

// import { loadSudoSiteIdReset } from "services/redux/actions/serviceDesk.js";

import ActualTimezoneDate from "components/Common/ActualTimezoneDate";
import TimezoneDate from "components/Common/TimezoneDate.js";

import Alert from "components/Common/Alert";

import Icon from "components/Icons/Icon";

import { saveAs } from "file-saver";

import Loading from "components/Loading";

import conxtdOut from "apis/conxtdOut";

import _ from "lodash";

import FILTER_TAG_COLOURS from "./FILTER_TAG_COLOURS.js";
import AddSingleSite from "./AddSingleSite/AddSingleSite.js";
import CreateEnterprise from "./AssetEditor/CreateEnterprise/CreateEnterprise.js";

import BulkImportSites from "./BulkSiteImport/BulkImportSites.js";
import ActionBar from "components/Common/ActionBar/ActionBar.js";
// import { select } from "../../../../node_modules/@storybook/addon-knobs/dist/index.js";
import DeleteSites from "./ActionBar/DeleteSites.js";

class DataTable extends React.Component {
  state = {
    previousDataTableState: {
      page: 0,
      pageSize: 20,
      sorted: [],
      filtered: [],
    },
    showImportSites: false,
    addSiteModalShow: false,
    createEnterpriseModalShow: false,
    selection: [],
    selectAll: false,
    filterExport: false,
  };

  componentDidMount = () => {
    this.props.dispatch(loadSiteAssetsReset());
  }

  // the table's page number is controlled from here, so that reloads triggered outside of the table
  // (deletes, external filters, the import/add site modals) can keep the displayed page in step with the data
  setTablePage = (page) => {
    this.setState((prevState) => (
      prevState.previousDataTableState.page === page
        ? null // already on that page - don't trigger a pointless re-render
        : { previousDataTableState: { ...prevState.previousDataTableState, page } }
    ));
  }

  componentDidUpdate = (prevProps) => {
    const externalFiltersChanged = !_.isEqual(prevProps.externalFilters, this.props.externalFilters);
    const { pageCount } = this.props.pagination;

    // both adjustments are made in a single update, so that the range check below sees the reset above it
    // rather than the page we were on beforehand
    this.setState((prevState) => {
      let page = prevState.previousDataTableState.page;

      // applying or clearing an external filter always requests page 1, so move the table back to it
      if (externalFiltersChanged) page = 0;

      // react-table clamps its own page when the page count shrinks, but it can't do that while the page
      // is controlled from here, so we have to clamp it ourselves
      if (pageCount && page >= pageCount) page = pageCount - 1;

      return page === prevState.previousDataTableState.page
        ? null // nothing to change - don't trigger a pointless re-render
        : { previousDataTableState: { ...prevState.previousDataTableState, page } };
    });

    if (this.state.selectAll) {
      if (externalFiltersChanged) {
        // with server side pagination and when select all is ticked, i.e. when we're tracking exclusions rather than selections,
        // we can't make an accurate calculation of how many and which items have been selected when the filters change.
        // the safest thing to do is to clear the selections (i.e. exclusions)
        this.setState({
          selection: [],
          selectAll: false,
        });
      }
    }
    const { tableFilters, externalFilters } = this.props;
    if (this.state.filterExport === false && (!_.isEmpty(tableFilters) || !_.isEmpty(externalFilters))) {
      this.setState({ filterExport: true }); 
    } else if (this.state.filterExport === true && (_.isEmpty(tableFilters) && _.isEmpty(externalFilters))) {
      this.setState({ filterExport: false });
    }
  }

  importSitesModalClose = () => {
    this.setState({ showImportSites: false });
  }

  toggleAll = () => {
    const { selectAll } = this.state;

    this.setState({
      selectAll: !selectAll,
      selection: [],
    });
  };

  deselect = () => {
    this.setState({ selection: [] });
    if (this.state.selectAll) {
      this.toggleAll();
    }
  };

  onClickExport = ( exportFiltered = false ) => {
    const {
      companyId,
      companyName,
      tableFilters,
      externalFilters,
    } = this.props;

    const params = {};
    if (tableFilters.length > 0) {
      tableFilters.forEach(f => 
        params[f.id] = f.value
      )
    }
    
    if (externalFilters.length > 0) {
      externalFilters.forEach(f => 
        params[f.id] = f.value
      )
    }

    const getExport = conxtdOut.post(
      `/Authake/getSitesReportExport/${companyId}`,
      !exportFiltered ? {} : this.state.filterExport && {
        ...params,
      },
      {
        responseType: "arraybuffer"
      }
    );

    getExport.then((response) => {
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      if (blob.size === 70) {
        Alert({
          text:
            "You will be sent an email which will contain your export",
          icon: "success",
          timerProgressBar: true,
          timer: 5000,
        });
      } else {
        saveAs(blob, companyName + ".xlsx");
      }

    }).catch((error) => {
      console.log("error", error.message);
        Alert({
          text: "Export failed, please try again later.",
          icon: "error",
          timerProgressBar: true,
          timer: 5000,
        });
    })
  }

  applyTableFilter = (filterValue, filterColumnDetails, columns) => {
    const {
      tableFilters,
      updateTableFilters,
    } = this.props;

    // re-construct the list of filters and incorporate the incoming new filter
    const newTableFilters = columns
      // start by looping through all the columns we have
      .map((column) => {
        // for each column, find any existing filter that is currently being applied to that column
        // from our list of current filters (tableFilters)
        const existingFilter = _.find(tableFilters, {"id": column.id});

        if (column.id === filterColumnDetails.id) {
          // if the id of the current column we're looping through matches the id of the incoming filtered column,
          // then we know that this is the one that's being changed
          return {
            id: column.id,
            value: filterValue,
            header: filterColumnDetails.Header,
            color: filterColumnDetails.filterTagColor ? filterColumnDetails.filterTagColor : "#191970",
          };
        } else if (existingFilter) {
          // if the id of the current column we're looping through does not match the id of the incoming filtered column,
          // but we do have an existing filter for that column, just return the filter unchanged
          return existingFilter;
        } else {
          // if the id of the current column we're looping through does not match the id of the incoming filtered column,
          // and also we do not have any existing filter, return an empty value, which can then be filtered out of the array
          return { value: "" };
        }
      })
      .filter((item) => {
        // filter the empty values out of the array
        return !!item.value;
      });

    // update the list used by the table component
    updateTableFilters(newTableFilters);

    console.log('newTableFilters: ', newTableFilters)

    if (this.state.selectAll) {
      // with server side pagination and when select all is ticked, i.e. when we're tracking exclusions rather than selections,
      // we can't make an accurate calculation of how many and which items have been selected when the filters change.
      // the safest thing to do is to clear the selections (i.e. exclusions)
      this.setState({
        selection: [],
        selectAll: false,
      });
    }
  }

  handleLoadCompanyStart = () => {
    const {
      companyId,
      tableFilters,
      externalFilters,
      pageSize,
    } = this.props;

    this.props.dispatch(
      loadCompanyStart({ 
        company_id: companyId, 
        requestPageNumber: 1, // tells the back end which page to serve (starts at 1, like normal page numbering)
        pageSize: pageSize,
        filters: tableFilters,
        externalFilters: externalFilters,
      })
    );
  }

  handleDeleteSites = () => {
    const { selection, selectAll } = this.state;
    const { pagination } = this.props;

    const selectedCount = selectAll
      ? pagination.count - selection.length
      : selection.length;

    if (selectedCount > 0) {
      Alert({
        text: `Are you sure you want to delete ${selectedCount} sites?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.value) {
          const { companyId, tableFilters, externalFilters } = this.props;

          let deleteSites = null;

          // table filters (text box filters)
          let tableFilterParams = {};
          if (tableFilters.length > 0) {
            tableFilters.forEach(filter => {
              tableFilterParams[filter.id] = String(filter.value);
            });
          }
          // external filters (dropdown filters)
          let extFilterParams = {};
          if (externalFilters.length > 0) {
            externalFilters.forEach(filter => {
              extFilterParams[filter.id] = String(filter.value);
            });
          }

          deleteSites = conxtdOut.post('/ServiceDesk/deleteMultipleSites', {
            "sudo_site_ids" : selection,
            "company_id": companyId,
            "select_all" : selectAll,
            // "params": {
              ...tableFilterParams,
              ...extFilterParams,
            // },
          })

          deleteSites.then((response) => {
            if (response.status === 200) {
              Alert({
                text: "Sites deleted successfully",
                icon: "success",
                timerProgressBar: true,
                timer: 5000,
              });
              this.setState({
                selection: [],
                selectAll: false
              });
              this.setTablePage(0); // the reload below asks for page 1, so move the table back to it
              this.props.dispatch(
                loadCompanyStart({
                  company_id: this.props.companyId,
                  requestPageNumber: 1, // tells the back end which page to serve (starts at 1, like normal page numbering)
                  pageSize: this.props.pageSize,
                  filters: tableFilters,
                  externalFilters: externalFilters,
                })
              );
            }
          }).catch((error) => {
            console.log("error", error.message);
            Alert({
              text: "Failed to delete sites, please try again later.",
              icon: "error",
              timerProgressBar: true,
              timer: 5000,
            });
          })
        }
      })
    }
  }

  handleViewAssets = () => {
    const { location } = this.props.history;
    this.props.history.push(`${location.pathname}/assets`);
  };
  
  handleViewManageEnterpriseAssociations = () => {
    const { location } = this.props.history;
    this.props.history.push(`${location.pathname}/manage-enterprise-associations`);
  };

  render() {
    const { 
      companyId,
      companyType,
      sudoSites,
      customFields,
      pagination,
      tableFilters,
      externalFilters,
      loadingCompany,
      location,
    } = this.props;
    const { selection, selectAll } = this.state;

    const selectedCount = selectAll
      ? pagination.count - selection.length
      : selection.length;

    const addSiteModalClose = () => {
      this.setState({ addSiteModalShow: false });
    }
    
    const addSiteModalShow = () => {
      this.setState({ addSiteModalShow: true });
    }
    
    const createEnterpriseModalClose = () => {
      this.setState({ createEnterpriseModalShow: false });
      // reload Sites table data on unmount
      setTimeout(() => {
        this.props.dispatch(loadCompanyCreateEnterpriseReset())
      }, 250)
      // ---------------------------------|
    }
    
    const createEnterpriseModalShow = () => {
      this.setState({ createEnterpriseModalShow: true });
    }

    let noDataMsg = "No data available...";

    const columns = [
      {
        key: "ID",
        Header: "Id",
        id: "id",
        width: 60,
        show: false,
        accessor: data => data.id,
      },
      {
        key: "SITE_REF",
        Header: "Site Ref",
        id: "site_ref",
        width: 80,
        filterTagColor: FILTER_TAG_COLOURS["site_ref"],
        accessor: data => data.site_ref,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "TRANSMITTER_REF",
        Header: "Transmitter Ref",
        id: "transmitter_ref",
        width: 120,
        filterTagColor: FILTER_TAG_COLOURS["transmitter_ref"],
        accessor: data => data.transmitter_ref,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "COMPANY",
        Header: "Site Name",
        id: "company",
        minWidth: 150,
        accessor: data => (
          <Link data-intercom-target={"site-editor-link-data-table"} to={`${location.pathname}/${data.id}${data.enterprises?.[0]?.id ? `?enterprise_id=${data.enterprises?.[0]?.id}` : ''}`}>
            <Icon className="fas fa-external-link-square-alt mr-2"></Icon>
            {data.company}
          </Link>
        ),
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "ENTERPRISES",
        Header: "Enterprises",
        id: "enterprises",
        minWidth: 310,
        accessor: data => data.enterprises,
        filterable: false,
        Cell: ({row}) => {
          return <div>
            {
              row.enterprises.map((enterprise, index) => {
                return <span key={index} className="mx-1">
                  <Tooltip
                    placement="left"
                    description="Go to Enterprise"
                  >
                    <Button
                      variant="primary"
                      onClick={() => {
                        this.props.history.push(`/enterprise/${enterprise.id}`);
                      }}
                    >
                      {enterprise.name}
                    </Button>
                  </Tooltip>
                </span>
              })
            }
          </div>
        }
      },
      {
        key: "ADDRESS_1",
        Header: "Address 1",
        id: "address1",
        width: 115,
        accessor: data => data.address1,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "ADDRESS_2",
        Header: "Address 2",
        id: "address2",
        width: 115,
        accessor: data => data.address2,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "TOWN",
        Header: "Town",
        id: "town",
        width: 115,
        accessor: data => data.town,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "COUNTRY",
        Header: "Country",
        id: "country",
        width: 80,
        filterTagColor: FILTER_TAG_COLOURS["country"],
        className: "text-center",
        // accessor: data => countryList().getLabel(data.country),
        accessor: data => data.country,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "POSTCODE",
        Header: "Postcode",
        id: "postcode",
        width: 90,
        accessor: data => data.postcode,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: companyType === "A" ? "INSTALLER" : "ARC",
        Header: companyType === "A" ? "Installer" : "ARC",
        id: companyType === "A" ? "installer" : "arc",
        width: 90,
        accessor: data => companyType === "A" ? data.installer.name : data.arcmap.name,
        filterable: false,
        show: !!companyType
      },
      {
        key: "CONTRACT_NUMBER",
        Header: "Contract Number",
        id: "contract_number",
        width: 130,
        filterTagColor: FILTER_TAG_COLOURS["contract_number"],
        accessor: data => data.contract_number,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "PRODUCT_DESCRIPTION",
        Header: "Product Description",
        id: "product_description",
        width: 150,
        filterTagColor: FILTER_TAG_COLOURS["product_description"],
        accessor: data => data.product_description,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
    ];

    if (customFields) {
      const fields = Object.keys(customFields);
      if (fields.length >= 1) {
        const customTagColours = FILTER_TAG_COLOURS["custom"];
        fields.forEach((field, index) => {
          let tagColorIndex = index;
          while (tagColorIndex >= customTagColours.length) {
            tagColorIndex = tagColorIndex - customTagColours.length;
          }
          columns.push({
            key: field,
            Header: customFields[field],
            id: field,
            width: 110,
            filterTagColor: customTagColours[tagColorIndex],
            accessor: data => _.find(data.custom_fields, { 'text_field': field })?.value,
            Filter: ({ column }) => {
              return <input
                type="text"
                id={`${column.id}_filter_input`}
                onChange={_.debounce((e) => {
                  this.applyTableFilter(e.target.value, column, columns);
                }, 300)}
              />
            }
          })
        })
      }
    }

    columns.push(
      {
        key: "LAST_EVENT_ACKED",
        Header: "Last Event Time",
        id: "occurrence",
        minWidth: 160,
        filterable: false,
        accessor: data => {
          const occurrence = {
            acked: data.last_event_acked,
            timezone: data.timezone,
            format: "HH:mm ddd DD/MM/YYYY",
          }
          return occurrence;
        },
        Cell: ({ row }) => {
          const timezone = row.created;
          return <ActualTimezoneDate occurrence={row.occurrence} timezone={timezone} />
        },
      },
      {
        key: "CREATED",
        Header: "Created Date",
        id: "created",
        minWidth: 160,
        filterable: false,
        accessor: data => {
          const created = {
            acked: data.created,
            timezone: data.timezone,
            format: "HH:mm ddd DD/MM/YYYY",
          }
          return created;
        },
        Cell: ({ row }) => {
          const occurrence = row.created;
          return (
            <TimezoneDate
              date={occurrence.acked}
              timezone={occurrence.timezone} 
              format={occurrence.format} 
              hideTimezone={true}
            />
          )
        },
      },
    );

    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

    return (
      <div>
          <ButtonToolbar className="p-2">
            {
              !mobile && <DropdownButton
                id="dropdown-export"
                title="Export"
                disabled={(sudoSites.length === 0)}
              >
                <Dropdown.Item onClick={() => this.onClickExport()}>
                  <Icon className="far fa-file-excel" /> Export All
                </Dropdown.Item>
                <Dropdown.Item className={`${!this.state.filterExport ? 'disabled' : ''}`} onClick={() => this.onClickExport( true )}>
                  <Icon className="fas fa-filter" /> Export Filtered
                </Dropdown.Item>
              </DropdownButton>
            }

            {/* Enterprises Dropdown */}
            <DropdownButton
              title="Enterprises"
              className="ml-1"
              data-intercom-target={"enterprises-button"}
            >
              <Dropdown.Item
                data-intercom-target={"create-enterprise-dropdown-item"}
                onClick={() => createEnterpriseModalShow()}
              >
                <span><Icon className="fas fa-plus mr-2" title="Create Enterprise" />Create New Enterprise</span>
              </Dropdown.Item>
              <Dropdown.Item
                data-intercom-target={"manage-enterprise-associations-dropdown-item"}
                onClick={() => this.handleViewManageEnterpriseAssociations()}
              >
                <span><Icon className="fas fa-tasks mr-2" title="View Enterprise Associations" />Manage Enterprise Associations</span>
              </Dropdown.Item>
            </DropdownButton>

            <DropdownButton
              title="Sites"
              className="ml-1"
              data-intercom-target={"sites-button-company"}
            >
              <Dropdown.Item
                data-intercom-target={"add-site-select-company"}
               onClick={() => {
                addSiteModalShow()
              }}
              >
                <span><Icon className="fas fa-plus mr-2" title="Add Single Site" />Add Site</span>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => {
                this.setState({
                  showImportSites: true 
                });
              }}>
                <span><Icon className="fas fa-file-import mr-2" title="Import" />Import Sites</span>
              </Dropdown.Item>
            </DropdownButton>
            <Button className="ml-1" onClick={this.handleViewAssets} data-intercom-target={"company-assets-index"}>
              <span>Assets </span>
              <Icon className="fas fa-tag pl-1" />
            </Button>
            <div style={{ width: "55px"}}>{loadingCompany && <Loading center />}</div>
          </ButtonToolbar>

          {/* CheckboxTableManual - manual mode for server-side pagination */}
          <CheckboxTableManual
            columns={columns}
            data={sudoSites}
            noDataText={noDataMsg}
            loadDataAction={loadCompanyStart}
            loadDataParams={{
              company_id: companyId,
              externalFilters: externalFilters,
            }}
            handler={(dataTableState) => this.setState({ previousDataTableState: dataTableState })} // keeps a record of the table state, so that modals (e.g. import/add site) can reload the data on the same page
            page={this.state.previousDataTableState.page} // controlled, so that reloads triggered outside of the table stay in step with the displayed page
            onPageChange={this.setTablePage}
            pages={pagination.pageCount}
            defaultPageSize={20}
            filterable
            filtered={tableFilters}
            // sortable={sudoSites.length > 0}
            sortable={false}
            keyField="id" // key for the checkbox selections
            className="-striped -highlight"
            allowSelectAll={true}
            // toggleSelection={toggleSelection}              // for the checkbox functionality, EITHER pass a custom toggleSelection function,
            // isSelected={isSelected}                        // and a custom isSelected function,
            selection={selection}                                                       // OR pass a selection array,
            setSelection={(selection) => this.setState({ selection: [...selection] })}  // and a setter for the array.
            selectAll={selectAll}                             // for the select all functionality, pass a selectAll flag (show whether select all is checked or not),
            toggleAll={this.toggleAll}                        // and EITHER pass a custom toggleAll function
            // setSelectAll={(selectAll) => this.setState({ selectAll: selectAll })}    // OR pass a setter for the flag
          />

          {selectedCount > 0 && (
            <ActionBar
              serverSideSelectAll={selectAll}
              selection={selection}
              totalCount={pagination.count}
              deselect={this.deselect}
            >
              {/* Delete Sites */}
              <DeleteSites 
                handleDeleteSites={this.handleDeleteSites}
              />
            </ActionBar>
          )}

        <AddSingleSite
          showModal={this.state.addSiteModalShow}
          handleClose={addSiteModalClose} 
          handleShow={addSiteModalShow} 
          companyName={this.props.companyName} 
          companyType={this.props.companyType} 
          installerOptions={this.props.installerOptions} 
          arcMapOptions={this.props.arcMapOptions} 
          installerOption={this.props.installerOption} 
          arcMapOption={this.props.arcMapOption} 
          companyId={companyId}
          previousDataTableState={this.state.previousDataTableState}
          externalFilters={externalFilters}
        />
        
        <BulkImportSites
          show={this.state.showImportSites} 
          onHide={this.importSitesModalClose}
          companyId={companyId}
          companyType={this.props.companyType} 
          companyName={this.props.companyName}
          previousDataTableState={this.state.previousDataTableState}
          externalFilters={externalFilters}
        />
        
        <CreateEnterprise
          showModal={this.state.createEnterpriseModalShow}
          handleClose={createEnterpriseModalClose} 
          handleShow={createEnterpriseModalShow} 
          handleLoadCompanyStart={this.handleLoadCompanyStart}
          companyName={this.props.companyName} 
          companyType={this.props.companyType} 
          companyId={companyId}
          // installerOptions={this.props.installerOptions}
          // arcMapOptions={this.props.arcMapOptions}
          // installerOption={this.props.installerOption} 
          // arcMapOption={this.props.arcMapOption} 
          // previousDataTableState={this.state.previousDataTableState} 
        />

      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    sudoSites: state.company.data.sudoSites,
    customFields: state.company.filterOptions.customFields,
    pagination: state.company.data.pagination,
    loadingCompany: state.company.loadingCompany,
    pageSize: state.company.pageSize,
  };
};
export default withRouter(connect(mapStateToProps)(DataTable));